const BASE_URL =
  process.env.REACT_APP_API_URL || "https://perfectshelters-backend-production.up.railway.app";

export default BASE_URL;
